"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_sparql_serialize_1 = require("@comunica/bus-sparql-serialize");

var core_1 = require("@comunica/core");

var sparqljson_to_tree_1 = require("sparqljson-to-tree");

var stream_1 = require("stream");
/**
 * A comunica Tree SPARQL Serialize Actor.
 */


var ActorSparqlSerializeTree =
/*#__PURE__*/
function (_bus_sparql_serialize) {
  _inherits(ActorSparqlSerializeTree, _bus_sparql_serialize);

  function ActorSparqlSerializeTree(args) {
    _classCallCheck(this, ActorSparqlSerializeTree);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorSparqlSerializeTree).call(this, args));
  }
  /**
   *
   * @param {BindingsStream} bindingsStream
   * @param context
   * @param {IConverterSettings} converterSettings
   * @return {Promise<string>}
   */


  _createClass(ActorSparqlSerializeTree, [{
    key: "testHandleChecked",
    value: function () {
      var _testHandleChecked = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(action.type !== 'bindings')) {
                  _context.next = 2;
                  break;
                }

                throw new Error('This actor can only handle bindings streams.');

              case 2:
                return _context.abrupt("return", true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function testHandleChecked(_x) {
        return _testHandleChecked.apply(this, arguments);
      }

      return testHandleChecked;
    }()
  }, {
    key: "runHandle",
    value: function () {
      var _runHandle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action, mediaType) {
        var data, resultStream;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = new stream_1.Readable();

                data._read = function () {
                  return;
                };

                resultStream = action.bindingsStream;
                resultStream.on('error', function (e) {
                  return data.emit('error', e);
                });
                ActorSparqlSerializeTree.bindingsStreamToGraphQl(resultStream, action.context, {
                  materializeRdfJsTerms: true
                }).then(function (result) {
                  data.push(JSON.stringify(result, null, '  '));
                  data.push(null);
                });
                return _context2.abrupt("return", {
                  data: data
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function runHandle(_x2, _x3) {
        return _runHandle.apply(this, arguments);
      }

      return runHandle;
    }()
  }], [{
    key: "bindingsStreamToGraphQl",
    value: function bindingsStreamToGraphQl(bindingsStream, context, converterSettings) {
      var actionContext = core_1.ensureActionContext(context);
      return new Promise(function (resolve, reject) {
        var bindingsArray = [];
        var converter = new sparqljson_to_tree_1.Converter(converterSettings);
        var schema = {
          singularizeVariables: actionContext.get('@comunica/actor-init-sparql:singularizeVariables') || {}
        };
        bindingsStream.on('error', reject);
        bindingsStream.on('data', function (bindings) {
          var rawBindings = bindings.toJS();
          var reKeyedBindings = {}; // Removes the '?' prefix

          for (var key in rawBindings) {
            var bindingValue = rawBindings[key];

            if (bindingValue) {
              reKeyedBindings[key.substr(1)] = bindingValue;
            }
          }

          bindingsArray.push(reKeyedBindings);
        });
        bindingsStream.on('end', function () {
          resolve(converter.bindingsToTree(bindingsArray, schema));
        });
      });
    }
  }]);

  return ActorSparqlSerializeTree;
}(bus_sparql_serialize_1.ActorSparqlSerializeFixedMediaTypes);

exports.ActorSparqlSerializeTree = ActorSparqlSerializeTree;